import { gql } from '@apollo/client';

export default gql`
	type Mutation {
		changePreferredLang(id: String, newLang: String): String
	}
`;
